/**
 * hvsin — 核心类型定义
 *
 * 依赖注入与插件化的基础类型。
 * 所有类型均为纯 TypeScript 类型，不包含运行时逻辑。
 */
// ==================== Mod 状态与事件 ====================
/** Mod 状态枚举 */
export var ModState;
(function (ModState) {
    ModState["Unloaded"] = "unloaded";
    ModState["Loading"] = "loading";
    ModState["Loaded"] = "loaded";
    ModState["Error"] = "error";
    ModState["Unloading"] = "unloading";
})(ModState || (ModState = {}));
/** EventBusService 的接口标签，用于 DI 接口式引用 */
export const EVENT_BUS_INTERFACE_TAG = 'IEventBusService';
//# sourceMappingURL=types.js.map